<template>
    <div class="">
        <div class="hotline">
            <div>
                <div v-html="$util.regImg(telDetail)"></div>
            </div>
            <img :src="require('@/assets/img/phone.png')" >
        </div> 
    </div>
</template>
<script>
export default {
    data(){ 
        return{ 
            telDetail:null
        }
    },
    created(){
        this.getTel()
    },
    methods:{
        getTel(){
            this.$get('/web/doorProtect/getTelephoneConfig').then(res=>{ 
                if(res.success){ 
                    this.telDetail=res.message
                }
            })
        },
    }
}
</script>
<style scoped lang='scss'>

.hotline{
    width: calc(100% - 150px);
    font-size: 16px;
    text-align: left;
    margin-left: 100px;
    margin-top: 22px;
    padding-bottom: 40px;
    font-family: SourceHanSansCN-Regular;
        p{
            width: 100%!important;
            font-size: 16px;
            line-height: 30px;
            padding-bottom: 10px;
        }
        ul li{
            list-style: none;
        }
        img{
            width: 52px;
            height: 52px;
            position: absolute;
            left: 3%;
            top: 30px;
        }
    
}
</style>
